import {
  CheckboxContext,
  CheckboxPassThroughOptions,
  CheckboxProps,
} from 'primereact/checkbox';
import { classNames } from 'primereact/utils';

export const PTCheckbox: CheckboxPassThroughOptions = {
  root: {
    className: 'ax-checkbox',
  },
  box: ({
    props,
    context,
  }: {
    props: CheckboxProps;
    context: CheckboxContext;
  }) => ({
    className: classNames(
      'ax-checkbox__box',
      'transition-colors duration-100',
      {
        'ax-checkbox__box--unchecked': !context.checked,
        'ax-checkbox__box--checked': context.checked,
      },
      {
        'cursor-default opacity-60': props.disabled,
      },
    ),
  }),
  icon: {
    className: 'w-2 h-2 transition-all duration-100 !text-white text-base',
  },
};
